import {mailReg, numberReg} from "./const";

export function isValidTel(telInput) {
    return telInput.value.length === telInput.maxLength;
}

export function isValidMail(mailInput) {
    mailInput.value = mailInput.value.trim();
    return mailReg.test(mailInput.value);
}

export function isValidNumber(numberInput) {
    return numberReg.test(numberInput.value);
}

// recaptcha
export function loadCaptchaToken(form, inputSelector) {
    const selector = inputSelector || "input[name='captcha_token']";
    /* eslint-disable */
    if (form && window.config && window.config.recaptcha.public_key && typeof grecaptcha !== "undefined") {
        const publicKey = window.config.recaptcha.public_key;
        grecaptcha.ready(function () {
            grecaptcha.execute(publicKey, {action: "submit"})
                .then(function (token) {
                    form.querySelectorAll(selector).forEach((input) => {
                        input.value = token;
                    });
                });
        });
    }
    /* eslint-enable */
}
